<template>
  <div class="bi-table-card stat-box">
    <div class="bi-table-card--items">
      <div
        v-for="vacancy of topVacancies"
        :key="vacancy.vacancy_id"
        class="bi-table-card--item campaign-item"
      >
        <TopVacanciesInner :id="vacancy.VacancyID" />
        <div class="text-right">
          <span class="application-amount">
            {{ vacancy.numberOfApplications }}
          </span>
        </div>
      </div>
    </div>
    <div class="bi-table-card-link">
      <router-link :to="{ name: 'vacancy.overview' }" class="overview-link">
        Alle Stellen anzeigen <i class="fal fa-arrow-right"></i>
      </router-link>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import TopVacanciesInner from "./TopVacanciesInner.vue";

export default {
  components: {
    TopVacanciesInner
  },
  props: ["startDate", "endDate"],
  data() {
    return { topVacancies: null };
  },
  apollo: {
    topVacancies: {
      query: gql`
        query TopVacancies($number: Int!, $start: Time, $end: Time) {
          topVacancies(number: $number, start: $start, end: $end) {
            VacancyID
            numberOfApplications
          }
        }
      `,
      variables() {
        return {
          number: 8,
          start: this.startDate,
          end: this.endDate
        };
      }
    }
  }
};
</script>
